import {Component, HostListener} from '@angular/core';
import {NgIf} from "@angular/common";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    imports: [
        NgIf
    ],
    styleUrls: ['./header.component.css']
})
export class HeaderComponent {
    isMenuOpened: boolean = false;

    @HostListener('document:click')
    private clickOutside() {
        this.isMenuOpened = false;
    }

    toggleMenu(event: Event) {
        this.isMenuOpened = !this.isMenuOpened
        event.stopPropagation()
    }
}

